<template>
  <BaseChart :options="mergedOption" />
</template>

<script>
import { deepMerge } from '@/utils/object';
import BaseChart from './BaseChart';

export default {
  name: 'AppChart',
  components: {
    BaseChart,
  },
  props: {
    options: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    appChartOptions() {
      return {
        chart: {
          type: 'area',
        },
        title: {
          text: null,
        },
        credits: {
          enabled: false,
        },
        tooltip: {
          shared: true,
        },
        plotOptions: {
          series: {
            fillOpacity: 0.4,
          },
          area: {
            stacking: 'normal',
          },
        },
      };
    },
    mergedOption() {
      const result = deepMerge(this.appChartOptions, this.options);
      return result;
    },
  },
};
</script>
